export const PUBLIC_BACKGROUND = '/assets/public/public-stage-reference-v2.webp';
export const ACTIVATION_TITLE = '/assets/public/titles/activation-title-v3.webp';
export const HOME_TITLE = '/assets/public/titles/home-title-v3.webp';
export const QUIZ_BACKGROUND = '/assets/backgrounds/quiz-v1.webp';

type ImagePriority = 'high' | 'low' | 'auto';

const pendingImages = new Map<string, Promise<void>>();

/**
 * Fetch and decode an image once so a route never has to reveal it progressively.
 * Failed images resolve as well, which keeps a network error from trapping the user
 * on a loading screen forever.
 */
export function preloadImage(src: string, priority: ImagePriority = 'auto'): Promise<void> {
  const existing = pendingImages.get(src);
  if (existing) return existing;

  const pending = new Promise<void>((resolve) => {
    const image = new Image();
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };

    const decodeAndFinish = () => {
      if (typeof image.decode !== 'function') {
        finish();
        return;
      }
      image.decode().catch(() => undefined).finally(finish);
    };

    image.decoding = 'async';
    image.fetchPriority = priority;
    image.onload = decodeAndFinish;
    image.onerror = finish;
    image.src = src;

    if (image.complete) decodeAndFinish();
  });

  pendingImages.set(src, pending);
  return pending;
}
